/**
 * Checks whether a section has at least one system field or custom field.
 * @param {{ systemFields?: Object, customFields?: Object }} [section] Section fields.
 * @returns {boolean} `true` when the section has any field, otherwise `false`.
 */
export const hasFields = ({ systemFields = {}, customFields = {} } = {}) =>
  Object.keys({ ...systemFields, ...customFields }).length > 0

/**
 * Checks whether a section has at least one field the user can edit.
 * @param {{ systemFields?: Object, customFields?: Object }} [section] Section fields.
 * @returns {boolean} `true` when at least one field is not `disabled`, otherwise `false`.
 */
export const hasEditableFields = ({ systemFields = {}, customFields = {} } = {}) =>
  Object.values({ ...systemFields, ...customFields }).some((field) => !field?.disabled)
